import { type ICellRendererParams } from '@mint-lib/ag-grid/community';

import { Typography } from '@myn/mui';

const LabelCell = ({ data }: ICellRendererParams) => {
  const typographyVariant =
    data && !data.category ? 'overline01' : 'bodyShort02';
  return <Typography variant={typographyVariant}>{data?.name}</Typography>;
};
export { LabelCell };
